import type { TRevokeStatus } from "models/IntegrationActorPermissionModel";

import { List, Record } from "immutable";

import { IntegrationActorModel } from "./IntegrationActorModel";
import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";
import { TicketPermissionModel } from "./TicketPermissionModel";

const defaults = {
  actor: null as IntegrationActorModel | null,
  id: "",
  revokeStatus: "notRevoking" as TRevokeStatus,
  role: null as IntegrationResourceRoleModel | null,
  ticketPermissions: null as List<TicketPermissionModel> | null,
};

export class UserEntitlementModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { actor, id, revokeStatus, role, ticketPermissions } = data as typeof defaults;
    return new UserEntitlementModel({
      actor: actor ? IntegrationActorModel.fromServerData(actor) : null,
      id,
      revokeStatus,
      role: role ? IntegrationResourceRoleModel.fromServerData(role) : null,
      ticketPermissions: ticketPermissions ? List(ticketPermissions.map(TicketPermissionModel.fromServerData)) : List(),
    });
  }
}
